/* eslint-disable  */
//@ts-nocheck
import React, { ReactNode, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';

import { useModal } from '@client/components/common/Modal';
import { MediaDropbox } from '@client/components/common/inputs/ImageDropbox';
import { ErrorVideoModal } from '@client/components/landing-page-builder/Modals';
import { FieldTitle } from '@client/components/landing-page-builder/RedStarTitle';
import Spinner from '@client/components/Spinner';

export const LandingMediaDropbox = ({
  value,
  onChange,
  label,
  type,
  icon,
  children,
  validationText,
  errorMsg,
  variant = 'gray',
  short,
  optional = false,
  upload,
}: {
  upload: (f: File) => Promise<unknown>;
  value: string | null;
  onChange: (val: string) => any;
  label: string;
  type: 'image' | 'video';
  icon: string;
  children: ReactNode;
  validationText: ReactNode;
  errorMsg: string;
  variant?: 'gray' | 'white';
  short?: boolean;
  optional?: boolean;
}) => {
  const [state, setState] = useState<'initial' | 'uploading' | 'uploaded'>(
    value ? 'uploaded' : 'initial',
  );

  useEffect(() => {
    setState(value ? 'uploaded' : 'initial');
  }, [value]);

  const [error, setError] = useState<any>(null);
  const [errorType, setVideoErrorType] = useState<
    'duration' | 'format' | 'size'
  >(null);

  const videoErrorModal = useModal(ErrorVideoModal);

  function checkFileDuration(file) {
    return new Promise((resolve) => {
      const video = document.createElement('video');
      video.src = URL.createObjectURL(file);

      video.onloadedmetadata = function () {
        window.URL.revokeObjectURL(video.src);
        resolve(video.duration);
      };
    });
  }

  const handleFileChange = async (file: File) => {
    if (type === 'video') {
      const videoSizeLimit = 200000000; // 200mb
      const videoDurationLimit = 60; // 60s
      const format = file.name.split('.').pop().toLowerCase();

      const videoDuration = await checkFileDuration(file);

      if (videoDuration > videoDurationLimit) {
        setVideoErrorType('duration');
        videoErrorModal.open();
        return;
      }

      // if (format !== 'mp4') {
      //   setVideoErrorType('format');
      //   videoErrorModal.open();
      //   return;
      // }

      if (file.size > videoSizeLimit) {
        setVideoErrorType('size');
        videoErrorModal.open();
        return;
      }
    }

    const reader = new FileReader();

    reader.onload = async (event) => {
      if (!event.target?.result) return;

      try {
        setState('uploading');
        setError(null);

        const url = await upload(file);

        onChange(url);
        setState('uploaded');
      } catch (err) {
        console.error(err);
        setError('Something went wrong!');
        setState('initial');
      }
    };

    reader.readAsDataURL(file);
  };

  const ThumbnailElement = type === 'video' ? 'video' : 'img';

  return (
    <div className="flex flex-col">
      {label ? <FieldTitle optional={optional} title={label} /> : null}
      <p className="max-w-[260px] ">{validationText}</p>
      <div
        className={`${
          short ? 'max-w-[550px] h-[70px]' : 'h-[260px] w-[260px]'
        }  flex items-center justify-center flex-grow rounded-[6px]
        ${{ gray: 'bg-[#F1F3F9]', white: 'bg-white' }[variant]}
      `}
      >
        {state === 'initial' ? (
          <div className="media-box-wrapper">
            <MediaDropbox
              onChange={handleFileChange}
              icon={icon as any}
              type={type}
              {...{ short }}
            >
              {children}
            </MediaDropbox>
          </div>
        ) : null}
        {state === 'uploaded' ? (
          <div className="relative h-full w-full flex justify-center">
            <div className="absolute top-[4px] right-[4px] flex items-center justify-center bg-[#151e34] bg-opacity-50 w-[24px] h-[24px] rounded-full cursor-pointer">
              <FontAwesomeIcon
                icon={faTimes as any}
                className="leading-none text-white text-sm"
                onClick={() => {
                  onChange(null);
                  setState('initial');
                }}
              />
            </div>
            <ThumbnailElement
              className="h-full rounded-[6px] -z-1 pointer-events-none"
              src={value}
            />
          </div>
        ) : null}
        {state === 'uploading' ? (
          <div>
            <div className="flex flex-col space-y-4 items-center">
              <Spinner />
              {short ? null : (
                <div className="font-semibold text-[#8F9BB3]">Uploading</div>
              )}
            </div>
          </div>
        ) : null}
      </div>
      {error ? <div className="text-[#6367ef] mt-2">{error}</div> : null}
      {errorMsg ? <div className="text-[#6367ef] mt-2">{errorMsg}</div> : null}
      <videoErrorModal.Popup errorType={errorType} />
    </div>
  );
};
